import * as R from 'ramda';

export default function EMController(
  $q,
  $scope,
  $location,
  $filter,
  $rootScope,
  serviceIds,
  loaderService,
  alerts,
  bcpDataService,
  userService,
  emDataService,
  orgDataService,
  ssDialogService,
  assessmentInProgressDialog,
) {
  const vm = this;

  vm.handleAccept = _handleAccept;
  vm.handleCancel = _handleCancel;
  vm.closeDialog = _closeDialog;
  vm.eulaAccepted = true;
  vm.appIsLoaded = false;
  vm.loaderService = loaderService;
  vm.canAddDepartment = false;
  vm.groupId = 14;
  vm.customerId = '';
  vm.departments = null;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    const dfdActivate = $q.defer();
    _initPermissions();

    _initEventListeners();
    userService.dfdRefreshed.promise.then(() => {
      vm.customerId = userService.user.customerId;
      _refresh().then(() => {
        dfdActivate.resolve();
      });
    });
    dfdActivate.promise.then(() => {
      _checkForExistingAssessment();
      vm.appIsLoaded = true;
    });
  }

  function _initEventListeners() {
    const dfdInit = $q.defer();

    $scope.$on('refreshDepartments',
      () => {
        _refresh().then(() => {
          $scope.$emit('departmentsRefreshed');
          dfdInit.resolve();
        });
      });
    
    $scope.$on('moveDepartmentRefresh',
      ($event, expandDepartmentArgs) => {
        _refresh().then(() => {
          $scope.$emit('departmentsRefreshed');

          R.forEach((dept) => {     
            if (dept.processes && dept.processes.length > 0) {
              R.forEach((process) => {
                process.functions.forEach((item) => {
                _filterFunctionDetails(item);
                _setMissingPermissions(item);
               })
              }, dept.processes);
            }
          }, vm.ITDepartment);
          R.forEach((dept) => {     
            if (dept.processes && dept.processes.length > 0) {
              R.forEach((process) => {
                process.functions.forEach((item) => {
                _filterFunctionDetails(item);
                _setMissingPermissions(item);
               })
              }, dept.processes);
            }
          }, vm.departments);
          $rootScope.$broadcast('expandDepartment', { departmentId: expandDepartmentArgs.departmentId });
          $rootScope.$broadcast('expandProcess', { processId: expandDepartmentArgs.processId });
          dfdInit.resolve();
        });
      });
    return dfdInit.promise;
  }

  function _initPermissions() {
    return userService.getUserPermissionSet('enterpriseModeling').then((permissions) => {
      vm.permissions = permissions;
    });
  }

  function _refresh() {
    const dfdRefresh = $q.defer();
    emDataService.getDepartments(vm.customerId).then((getDepartmentsResponse) => {
      vm.departments = getDepartmentsResponse.data.result;
      // Need to cycle through here because child 'activate' is only called on page load and not data update
      vm.departments.forEach((department) => {       
        department.teamMembers = $filter('filter')(
          department.users, {
            isBCPDepartmentTeamMember: true,
            isBCPDepartmentOwner: false,
          }
        );
        department.owners = $filter('filter')(
          department.users, {
            isBCPDepartmentOwner: true,
          }
        );
      });
      vm.ITDepartment = [];
      const pos = vm.departments.findIndex(item => item.isManaged === true);
      vm.ITDepartment.push(vm.departments[pos]);
      vm.departments.splice(pos, 1);
      emDataService.departments = vm.departments
      
      $rootScope.$broadcast('departmentsRefreshed');
      
      dfdRefresh.resolve();
    });
    return dfdRefresh.promise;
  }

  function _checkForExistingAssessment($event) {
    emDataService.hasIncompleteAssessment(vm.customerId).then((response) => {
      try {
        if (response.data.hasIncompleteBCPAssessment === true || response.data.hasIncompleteRiskAssessment === true) {
          //  _enterpriseModelingDialogService.showassessmentInProgressDialog();
          let message1 = '';
          let message2 = '';
          if (response.data.hasIncompleteBCPAssessment === true) {
            message1 = `There is an open BCP assessment "${response.data.bcpAssessmentName}"`;
          }
          if (response.data.hasIncompleteRiskAssessment === true) {
            // eslint-disable-next-line max-len
            message2 += `There is an open Information Security - Risk Assessment "${response.data.riskAssessmentName}"`;
          }

          ssDialogService.dialogs.enterpriseModeling.assessmentInProgressDialog = ssDialogService.alert(
            assessmentInProgressDialog.getOptions($event, { message1, message2 })
          );
          ssDialogService.show(ssDialogService.dialogs.enterpriseModeling.assessmentInProgressDialog);
        }
      } catch (error) {
        console.error(error);
      }
    });
  }

  function _handleAccept() {
    vm._closeDialog();
  }

  function _handleCancel() {
    vm._closeDialog();
  }

  function _closeDialog() {
    ssDialogService.hide(ssDialogService.dialogs.enterpriseModeling.assessmentInProgressDialog);
  }

  function _filterFunctionDetails(functionObj) {
    functionObj.functionITAssets = _filterOptions(functionObj.functionITAssetTypes);
    functionObj.functionNonITAssets = _filterOptions(functionObj.functionNonITAssetTypes);
    functionObj.functionVendors = _filterOptions(functionObj.functionVendors);

    functionObj.functionVendors.forEach((item) => {
      item.functionProducts = _filterOptions(item.functionProducts);
    });

    functionObj.vendorCount = functionObj.functionVendors.length;

    let fitaCount = 0;
    let fnitaCount = 0;

    if (functionObj.functionITAssets !== undefined) {
      fitaCount = functionObj.functionITAssets.length;
    }

    if (functionObj.functionNonITAssets !== undefined) {
      fnitaCount = functionObj.functionNonITAssets.length;
    }

    functionObj.assetCount = fitaCount + fnitaCount;
  }

  function _filterOptions(options) {
    return $filter('filter')(options, { isSelected: true, });
  }

  function _setMissingPermissions(functionObj) {
    // Set missing permissions
    if ((functionObj.canDelete === null) || (functionObj.canDelete === undefined)) {
      functionObj.canDelete = functionObj.canDeleteFunction;
    }
    if ((functionObj.canEdit === null) || (functionObj.canEdit === undefined)) {
      functionObj.canEdit = functionObj.canEditFunction;
    }
  }
}

EMController.$inject = [
  '$q',
  '$scope',
  '$location',
  '$filter',
  '$rootScope',
  'serviceIds',
  'loaderService',
  'alerts',
  'bcpDataService',
  'userService',
  'emDataService',
  'orgDataService',
  'ssDialogService',
  'assessmentInProgressDialog',
  'editDepartmentDialog'
];
